<div [id]="elementId" [ngClass]="{'tk-border-blue': isSelected}" class="flex bg-white px-4 py-2 grow rounded-lg cursor-pointer">

  <div class="flex items-center">
    <div [ngClass]="{'tk-i-arrow-top-blue w-3 h-3': model?.isAvailable, 'tk-i-person  w-4 h-4': !model?.isAvailable}">
    </div>
  </div>

  <div class="ml-3 flex flex-col">
    <div class="font-semibold  text-sm break-normal">{{model?.vehicleName | tkSlice:25}}</div>

    <div *ngIf="model?.isAvailable; else noEmailTemp" class="flex mt-1">
      <div class="rounded-full px-2" style="background-color: rgba(64, 199, 51, 0.1)">
        <div class="tk-c-green-2 text-xs">{{'handover.status-available' | translate}}</div>
      </div>
    </div>
    <ng-template #noEmailTemp>
      <span class="text-xs tk-c-gray mt-1">{{model?.driverFullName}}</span>
    </ng-template>

  </div>
</div>
